/* ═══════════════════════════════════════════════════════════════
   Lolitafetch — Theme JavaScript
   Interactive features matching Next.js design
   Performance revision: deferred media and interaction assets
   ═══════════════════════════════════════════════════════════════ */

(function() {
  var rateTables = {
    GB: [[300, 490], [500, 690], [1000, 1190], [2000, 2190]],
    US: [[500, 990], [1000, 1690], [1500, 2490], [2000, 3290]],
    DE: [[500, 1290], [1000, 1890], [2000, 3190]],
    FR: [[500, 1290], [1000, 1890], [2000, 3190]]
  };

  function formatGbp(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(Math.max(0, Number(cents || 0)) / 100);
  }

  function shippingRate(destination, weight) {
    var table = rateTables[destination];
    var grams = Number(weight || 0);
    if (!table || grams <= 0) return null;
    for (var index = 0; index < table.length; index += 1) {
      if (grams <= table[index][0]) return table[index][1];
    }
    return null;
  }

  function interpolate(template, values) {
    return Object.keys(values).reduce(function(copy, key) {
      return copy.split('__' + key + '__').join(values[key]);
    }, template || '');
  }

  function update(widget, subtotal, weight) {
    if (!widget) return;
    var threshold = Number(widget.dataset.threshold || 19900);
    var currentSubtotal = Math.max(0, Number(subtotal || 0));
    var currentWeight = Math.max(0, Number(weight || 0));
    var remaining = Math.max(0, threshold - currentSubtotal);
    var unlocked = remaining === 0;
    var progress = Math.min(100, (currentSubtotal / threshold) * 100);
    var country = widget.dataset.countryName || 'your destination';
    var rate = unlocked ? 0 : shippingRate(widget.dataset.destination, currentWeight);
    var progressCopy = unlocked
      ? widget.dataset.copyUnlocked
      : interpolate(widget.dataset.copyAway, { AMOUNT: formatGbp(remaining) });
    var estimateCopy;

    if (unlocked) {
      estimateCopy = interpolate(widget.dataset.copyEstimateFree, { COUNTRY: country });
    } else if (rate !== null) {
      estimateCopy = interpolate(widget.dataset.copyEstimate, {
        COUNTRY: country,
        AMOUNT: formatGbp(rate)
      });
    } else {
      estimateCopy = interpolate(widget.dataset.copyEstimateCheckout, { COUNTRY: country });
    }

    widget.dataset.subtotal = String(currentSubtotal);
    widget.dataset.weight = String(currentWeight);
    var copyNode = widget.querySelector('[data-shipping-progress-copy]');
    var fillNode = widget.querySelector('[data-shipping-progress-fill]');
    var trackNode = widget.querySelector('[data-shipping-progress-track]');
    var rateNode = widget.querySelector('[data-shipping-estimated-rate]');
    if (copyNode) copyNode.textContent = progressCopy;
    if (fillNode) fillNode.style.width = progress + '%';
    if (trackNode) {
      trackNode.setAttribute('aria-valuenow', String(Math.min(currentSubtotal, threshold)));
      trackNode.setAttribute('aria-valuetext', progressCopy);
    }
    if (rateNode) rateNode.textContent = estimateCopy;
  }

  window.lfShippingEstimate = { update: update };
})();

document.addEventListener('DOMContentLoaded', function() {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-shipping-estimate]').forEach(function(widget) {
    window.lfShippingEstimate.update(widget, widget.dataset.subtotal, widget.dataset.weight);
  });

  function loadCardHoverImage(target) {
    var card = target && target.closest ? target.closest('.lf-product-card') : null;
    var image = card && card.querySelector('img[data-lfm-hover-src]');
    if (!image) return;
    image.src = image.getAttribute('data-lfm-hover-src');
    image.removeAttribute('data-lfm-hover-src');
  }

  document.addEventListener('pointerover', function(event) {
    loadCardHoverImage(event.target);
  }, { passive: true });
  document.addEventListener('focusin', function(event) {
    loadCardHoverImage(event.target);
  });

  /* ─── Hero Carousel ─────────────────────────────────────── */
  
  let currentSlide = 0;
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  let heroInterval;

  function updateSlide(index) {
    slides.forEach(function(s) { s.classList.remove('active'); });
    dots.forEach(function(d) { d.classList.remove('active'); });
    if (slides[index]) slides[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');
    currentSlide = index;
  }

  window.goToSlide = function(index) {
    updateSlide(index);
    resetHeroTimer();
  };

  window.nextSlide = function() {
    updateSlide((currentSlide + 1) % slides.length);
    resetHeroTimer();
  };

  window.prevSlide = function() {
    updateSlide((currentSlide - 1 + slides.length) % slides.length);
    resetHeroTimer();
  };

  function resetHeroTimer() {
    clearInterval(heroInterval);
    if (reduceMotion || slides.length <= 1) return;
    heroInterval = setInterval(function() {
      updateSlide((currentSlide + 1) % slides.length);
    }, 6000);
  }

  if (!reduceMotion && slides.length > 1) {
    heroInterval = setInterval(function() {
      updateSlide((currentSlide + 1) % slides.length);
    }, 6000);
  }

  /* ─── TopBar Language Menu ──────────────────────────────── */

  window.toggleLangMenu = function(btn) {
    var menu = btn.nextElementSibling;
    if (menu && menu.classList.contains('lang-dropdown')) {
      menu.classList.toggle('open');
    }
  };

  /* ─── Header Scroll Behavior ────────────────────────────── */

  var topbar = document.querySelector('.site-topbar-row');
  var header = document.querySelector('.site-header-row');
  var lastScrollY = 0;
  var ticking = false;

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        var y = window.scrollY;
        
        if (y > 100 && topbar) {
          topbar.style.transform = 'translateY(-100%)';
          topbar.style.transition = 'transform 0.3s';
        } else if (topbar) {
          topbar.style.transform = 'translateY(0)';
        }

        if (y > 50 && header) {
          header.style.boxShadow = '0 2px 8px rgba(82,56,40,0.06)';
        } else if (header) {
          header.style.boxShadow = 'none';
        }

        lastScrollY = y;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  /* ─── Product Card Color Preview ─────────────────────────── */

  function findProductCard(el) {
    return el.closest('.lfm-product-card, .product-card, .nap-product-card');
  }

  function findProductImage(card) {
    return card && card.querySelector('.lfm-product-card__img--primary, .product-card__image--primary, .nap-product-card__image--primary');
  }

  function rememberOriginalImage(image) {
    if (image && !image.dataset.originalSrc) {
      image.dataset.originalSrc = image.getAttribute('src') || '';
    }
  }

  function activateColorPreview(swatch) {
    if (!swatch || !swatch.matches('[data-product-card-preview][data-color-image]')) return;

    var card = findProductCard(swatch);
    var image = findProductImage(card);
    var nextImage = swatch.dataset.colorImage;
    if (!card || !image || !nextImage) return;

    rememberOriginalImage(image);
    card.classList.add('is-color-previewing');
    card.querySelectorAll('[data-product-card-preview].is-active').forEach(function(active) {
      active.classList.remove('is-active');
      if (active.matches('button')) active.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    if (swatch.matches('button')) swatch.setAttribute('aria-pressed', 'true');
    image.setAttribute('src', nextImage);
  }

  document.addEventListener('mouseover', function(e) {
    var swatch = e.target.closest('[data-product-card-preview][data-color-image]');
    activateColorPreview(swatch);
  });

  document.addEventListener('mousemove', function(e) {
    var swatch = e.target.closest('[data-product-card-preview][data-color-image]');
    activateColorPreview(swatch);
  });

  document.addEventListener('focusin', function(e) {
    var swatch = e.target.closest('[data-product-card-preview][data-color-image]');
    activateColorPreview(swatch);
  });

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-product-card-preview][data-color-image]');
    if (!swatch) return;
    activateColorPreview(swatch);
    if (swatch.matches('a[href]')) return;
    e.preventDefault();
  });

  document.addEventListener('mouseout', function(e) {
    var card = e.target.closest('.lfm-product-card, .product-card, .nap-product-card');
    if (!card || card.contains(e.relatedTarget)) return;

    var image = findProductImage(card);
    if (image && image.dataset.originalSrc) {
      image.setAttribute('src', image.dataset.originalSrc);
    }
    card.classList.remove('is-color-previewing');
    card.querySelectorAll('[data-product-card-preview].is-active').forEach(function(active) {
      active.classList.remove('is-active');
      if (active.matches('button')) active.setAttribute('aria-pressed', 'false');
    });
  });

  /* ─── Smooth Scroll for Anchor Links ────────────────────── */

  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ─── Newsletter Form ───────────────────────────────────── */

  var nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function(e) {
      var email = this.querySelector('input[type="email"]');
      if (email && email.value) {
        // Shopify handles the form submission
      }
    });
  }

  /* ─── AJAX Cart ─────────────────────────────────────────── */

  var cartBusy = false;

  function setCartStatus(message) {
    var status = document.querySelector('[data-cart-status]');
    if (!status) {
      status = document.createElement('div');
      status.setAttribute('data-cart-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.position = 'absolute';
      status.style.width = '1px';
      status.style.height = '1px';
      status.style.overflow = 'hidden';
      status.style.clip = 'rect(0, 0, 0, 0)';
      document.body.appendChild(status);
    }
    status.textContent = message || '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span').forEach(function(node) {
      node.textContent = count;
      node.hidden = count === 0 && node.hasAttribute('data-cart-count');
    });
  }

  function refreshCartDrawer(cartSnapshot) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return Promise.all([
      cartSnapshot ? Promise.resolve(cartSnapshot) : fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(response) { return response.json(); }),
      fetch(root + '?sections=lfm-cart-drawer,main-cart', { headers: { 'Accept': 'application/json' } }).then(function(response) { return response.json(); })
    ]).then(function(results) {
      var cart = results[0];
      var sections = results[1];
      updateCartCount(cart.item_count);
      if (sections && sections['lfm-cart-drawer']) {
        var wrapper = document.getElementById('shopify-section-lfm-cart-drawer');
        if (wrapper) {
          var drawerDocument = new DOMParser().parseFromString(sections['lfm-cart-drawer'], 'text/html');
          var freshWrapper = drawerDocument.getElementById('shopify-section-lfm-cart-drawer');
          wrapper.innerHTML = freshWrapper ? freshWrapper.innerHTML : sections['lfm-cart-drawer'];
        }
        if (window.lfmBindCartDrawer) window.lfmBindCartDrawer();
      }
      if (sections && sections['main-cart']) {
        var cartWrapper = document.getElementById('shopify-section-main-cart');
        if (cartWrapper) {
          var cartDocument = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
          var freshCartWrapper = cartDocument.getElementById('shopify-section-main-cart');
          cartWrapper.innerHTML = freshCartWrapper ? freshCartWrapper.innerHTML : sections['main-cart'];
        }
      }
      updateAllCartSelections();
      syncDiscountFields();
      return cart;
    });
  }

  function getSavedDiscountCode() {
    try {
      return window.sessionStorage.getItem('lfmDiscountCode') || '';
    } catch (error) {
      return '';
    }
  }

  function saveDiscountCode(code) {
    try {
      window.sessionStorage.setItem('lfmDiscountCode', code);
    } catch (error) {}
  }

  function syncDiscountFields() {
    var code = getSavedDiscountCode();
    document.querySelectorAll('[data-cart-discount-code]').forEach(function(input) {
      if (!input.value) input.value = code;
    });
  }

  function applyDiscountCode(button) {
    var container = button.closest('.lfm-cart-discount');
    var input = container && container.querySelector('[data-cart-discount-code]');
    var message = container && container.querySelector('[data-cart-discount-message]');
    var code = input ? input.value.trim().toUpperCase() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }
    if (input) input.value = code;
    saveDiscountCode(code);
    if (message) message.textContent = button.getAttribute('data-success-message') || 'Discount code saved. It will be applied at checkout.';
    setCartStatus('Discount code saved.');
  }

  function updateCartSelection(scope) {
    if (!scope) return;
    var target = scope.getAttribute('data-cart-selection-scope');
    var selected = scope.querySelectorAll('[data-cart-select]:checked');
    var checkoutButton = document.querySelector('[data-checkout-selected][data-cart-selection-target="' + target + '"]');
    if (!checkoutButton) return;
    checkoutButton.disabled = selected.length === 0;
    var countNode = checkoutButton.parentElement && checkoutButton.parentElement.querySelector('[data-selected-count]');
    if (countNode) countNode.textContent = selected.length;
  }

  function updateAllCartSelections() {
    document.querySelectorAll('[data-cart-selection-scope]').forEach(updateCartSelection);
  }

  function checkoutSelected(button) {
    var target = button.getAttribute('data-cart-selection-target');
    var scope = document.querySelector('[data-cart-selection-scope="' + target + '"]');
    if (!scope) return;
    var selected = Array.from(scope.querySelectorAll('[data-cart-select]:checked'));
    if (selected.length === 0) {
      setCartStatus(button.getAttribute('data-empty-selection-message') || 'Select at least one item to continue.');
      button.focus();
      return;
    }

    var quantities = {};
    selected.forEach(function(input) {
      var variantId = input.getAttribute('data-variant-id');
      var quantity = Math.max(1, Number(input.getAttribute('data-quantity')) || 1);
      quantities[variantId] = (quantities[variantId] || 0) + quantity;
    });

    var parts = Object.keys(quantities).map(function(variantId) {
      return encodeURIComponent(variantId) + ':' + quantities[variantId];
    });
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';
    var checkoutUrl = root + 'cart/' + parts.join(',') + '?checkout';
    var discountCode = getSavedDiscountCode();
    if (discountCode) checkoutUrl += '&discount=' + encodeURIComponent(discountCode);
    window.location.assign(checkoutUrl);
  }

  function checkoutCart() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';
    var checkoutUrl = root + 'checkout';
    var discountCode = getSavedDiscountCode();
    if (discountCode) {
      checkoutUrl = root + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(root + 'checkout');
    }
    window.location.assign(checkoutUrl);
  }

  function addVariantToCart(variantId, button) {
    if (!variantId || cartBusy) return;
    cartBusy = true;
    var originalHtml = button ? button.innerHTML : '';
    var iconOnlyButton = button && button.querySelector('svg') && !button.textContent.trim();
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-adding');
      if (!iconOnlyButton) button.textContent = 'Adding...';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return response.json();
      })
      .then(function() {
        setCartStatus('Added to shopping bag.');
        return refreshCartDrawer();
      })
      .then(function() {
        if (window.openCartDrawer) window.openCartDrawer();
      })
      .catch(function(error) {
        var message = error && (error.description || error.message) ? (error.description || error.message) : 'Unable to add this item.';
        setCartStatus(message);
        if (button && !iconOnlyButton) button.textContent = message;
      })
      .finally(function() {
        window.setTimeout(function() {
          cartBusy = false;
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.classList.remove('is-adding');
            button.innerHTML = originalHtml;
          }
        }, 900);
      });
  }

  function changeCartLine(lineKey, quantity) {
    if (!lineKey || cartBusy) return;
    cartBusy = true;
    var openDrawer = document.getElementById('lfm-cart-drawer');
    var shouldReopenDrawer = !!(openDrawer && openDrawer.classList.contains('is-open'));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity) || 0) })
    })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return response.json();
      })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer(cart);
      })
      .then(function() {
        if (shouldReopenDrawer && window.openCartDrawer) window.openCartDrawer();
      })
      .catch(function(error) {
        setCartStatus(error && error.description ? error.description : 'Unable to update shopping bag.');
      })
      .finally(function() {
        cartBusy = false;
      });
  }

  function changeCartVariant(picker, changedSelect) {
    if (!picker || cartBusy) return;
    var dataNode = picker.querySelector('[data-cart-variant-json]');
    var selects = Array.from(picker.querySelectorAll('[data-cart-variant-select]'));
    if (!dataNode || selects.length === 0) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      setCartStatus(picker.getAttribute('data-update-error-message') || 'Unable to update this item.');
      return;
    }

    var variants = data.variants || [];
    var selectedOptions = selects.map(function(select) { return select.value; });
    var nextVariant = variants.find(function(variant) {
      return variant.available && variant.options.every(function(value, index) { return value === selectedOptions[index]; });
    });

    if (!nextVariant && changedSelect) {
      var changedIndex = Number(changedSelect.getAttribute('data-option-index'));
      nextVariant = variants.find(function(variant) {
        return variant.available && variant.options[changedIndex] === changedSelect.value;
      });
      if (nextVariant) {
        selects.forEach(function(select, index) { select.value = nextVariant.options[index]; });
      }
    }

    var currentVariantId = picker.getAttribute('data-current-variant-id');
    if (!nextVariant) {
      var currentVariant = variants.find(function(variant) { return String(variant.id) === String(currentVariantId); });
      if (currentVariant) selects.forEach(function(select, index) { select.value = currentVariant.options[index]; });
      setCartStatus(picker.getAttribute('data-unavailable-message') || 'This combination is unavailable.');
      return;
    }
    if (String(nextVariant.id) === String(currentVariantId)) return;

    cartBusy = true;
    var wasDrawer = !!picker.closest('#lfm-cart-drawer');
    selects.forEach(function(select) { select.disabled = true; });
    var quantity = Math.max(1, Number(picker.getAttribute('data-quantity')) || 1);
    var lineKey = picker.getAttribute('data-line-key');
    var formattedPrice = data.formattedPrices && data.formattedPrices[String(nextVariant.id)];
    var cartLine = picker.closest('.lfm-cart-item, .lfm-cart-line');
    var linePrice = cartLine && cartLine.querySelector('[data-cart-line-price]');
    if (linePrice && formattedPrice) linePrice.textContent = formattedPrice;
    picker.setAttribute('data-current-variant-id', nextVariant.id);

    var properties = data.properties || {};
    var hasProperties = Object.keys(properties).length > 0;
    var request;
    if (!hasProperties) {
      var updates = {};
      updates[lineKey] = 0;
      updates[String(nextVariant.id)] = quantity;
      request = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return response.json();
      });
    } else {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: nextVariant.id, quantity: quantity, properties: properties }] })
      }).then(function(response) {
        if (!response.ok) return response.json().then(function(error) { throw error; });
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        }).then(function(changeResponse) {
          if (!changeResponse.ok) return changeResponse.json().then(function(error) { throw error; });
          return changeResponse.json();
        });
      });
    }

    request
      .then(function(cart) { return refreshCartDrawer(cart); })
      .then(function() {
        setCartStatus('Shopping bag option updated.');
        if (wasDrawer && window.openCartDrawer) window.openCartDrawer();
      })
      .catch(function(error) {
        var message = error && (error.description || error.message) ? (error.description || error.message) : (picker.getAttribute('data-update-error-message') || 'Unable to update this item.');
        setCartStatus(message);
        picker.setAttribute('data-current-variant-id', currentVariantId);
        selects.forEach(function(select) { select.disabled = false; });
      })
      .finally(function() {
        cartBusy = false;
      });
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('form[action*="/cart/add"], form[data-ajax-cart-add]');
    if (!form) return;
    event.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[type="submit"]');
    addVariantToCart(idInput ? idInput.value : '', button);
  });

  document.addEventListener('click', function(event) {
    var discountButton = event.target.closest('[data-cart-discount-apply]');
    if (discountButton) {
      event.preventDefault();
      applyDiscountCode(discountButton);
      return;
    }

    var viewBagLink = event.target.closest('[data-cart-view-bag]');
    if (viewBagLink) {
      var savedCode = getSavedDiscountCode();
      if (savedCode) {
        event.preventDefault();
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        window.location.assign(root + 'discount/' + encodeURIComponent(savedCode) + '?redirect=' + encodeURIComponent(root + 'cart'));
      }
      return;
    }

    var addButton = event.target.closest('[data-cart-add-variant], [data-most-wanted-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addVariantToCart(addButton.getAttribute('data-cart-add-variant') || addButton.getAttribute('data-variant-id'), addButton);
      return;
    }

    var selectedCheckout = event.target.closest('[data-checkout-selected]');
    if (selectedCheckout) {
      event.preventDefault();
      checkoutSelected(selectedCheckout);
      return;
    }

    var cartCheckout = event.target.closest('[data-checkout-cart]');
    if (cartCheckout) {
      event.preventDefault();
      checkoutCart();
      return;
    }

    var changeButton = event.target.closest('[data-cart-change]');
    if (changeButton) {
      event.preventDefault();
      changeCartLine(changeButton.getAttribute('data-line-key'), changeButton.getAttribute('data-quantity'));
      return;
    }
  });

  document.addEventListener('change', function(event) {
    var variantSelect = event.target.closest('[data-cart-variant-select]');
    if (variantSelect) {
      changeCartVariant(variantSelect.closest('[data-cart-variant-picker]'), variantSelect);
      return;
    }

    var cartSelection = event.target.closest('[data-cart-select]');
    if (cartSelection) {
      updateCartSelection(cartSelection.closest('[data-cart-selection-scope]'));
      return;
    }

    var input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    changeCartLine(input.getAttribute('data-line-key'), input.value);
  });

  document.addEventListener('DOMContentLoaded', function() {
    updateAllCartSelections();
    syncDiscountFields();
  });

});
